import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { Analytics } from "@/components/Analytics";
import Home from "@/pages/Home";
import Archive from "@/pages/Archive";
import Detail from "@/pages/Detail";
import MapView from "@/pages/MapView";
import SearchResults from "@/pages/SearchResults";
import About from "@/pages/About";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <HelmetProvider>
        <BrowserRouter>
          <Analytics />
          <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#121215", border: "1px solid #23252E", color: "#EAE6D7" } }} />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/map" element={<MapView />} />
              <Route path="/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/:segment" element={<Archive />} />
              <Route path="/:segment/:slug" element={<Detail />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </HelmetProvider>
    </AuthProvider>
  );
}

export default App;
